import { useLocalStorage } from '@frontend/web-storage';

export const WEB_DEUB_KEY = 'debug-web';

export function useDebugMode() {
  const [isDebugMode, setDebugMode] = useLocalStorage({ key: WEB_DEUB_KEY, defaultValue: false });

  return [isDebugMode, setDebugMode] as [isDebugMode: boolean, setDebugMode: (value: boolean) => void];
}
